import { Link } from "@mui/material";

export interface FooterButtonProps {
  label: string;
  href: string;
  fontWeight?: string;
  color?: string;
}

const FooterButton = (prop: FooterButtonProps) => {
  return <Link href={prop.href} color="inherit" sx={{
    textDecoration: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    textAlign: 'center',
    display: 'inline-block',
    fontWeight: prop.fontWeight ? prop.fontWeight : 'default',
    color: prop.color ? prop.color : 'inherit',
  }}>{prop.label}</Link>
}

export default FooterButton;